import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { LanguagesRes } from 'shared/types/general.types'
import { AuthContext } from 'store'

export const useFetchLanguages = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const fetchLanguages = () =>
		axiosPrivate
			.options(apiRoutes.settings)
			.then((res) => res?.data?.actions?.PUT?.default_language?.choices)

	const { data: languages, isLoading: languagesIsLoading } = useQuery<LanguagesRes>({
		queryKey: queryKeys.languages.all,
		queryFn: fetchLanguages,
		enabled: !!auth.accessToken
	})

	return {
		languages,
		languagesIsLoading
	}
}
